export enum PaymentType {
  CASH = 1,
  CREDIT = 2,
  BANK_TRANSFER = 4,
  CARD = 6,
  MULTIPLE = 7,
  LINK = 100,
}
